import React, { useContext, useEffect, useState } from 'react';
import { Store } from './Store';
import { BrowserRouter, Route, useHistory } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Container, Paper, Box, Button, Dialog,  Typography} from '@material-ui/core';
//import CoffeeLogo from './assets/image/Cofee_logo.png';
//import splash1 from './assets/image/splash1.png';
//import hh from './assets/image/take-a-coffee-sign-icon-hot-cup-vector-10871825.jpg';
//import splash2 from './assets/image/splash2.png';
//import splash3 from './assets/image/splash3.png';
 
const SplashScreen = ({onFinish}) => {
    const { state, dispatch } = useContext(Store);
   let { setting } = state.userSetting;
  console.log(setting);
      const history = useHistory();
 if(!setting){
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }
  let { promos } = state.promos;


  const splashScreens = promos.filter(pr => pr.useAt == 'ONLINE_SPLASH');
  // [
  //   { image: splash1, text: 'Welcome to Matari Cafe!' },
  //   { image: splash2, text: 'We love to serve best' },
  //   { image: splash3, text: 'Let’s find your choice and order!' },
  // ];
  const [currentSplash, setCurrentSplash] = useState(0);
  const [showSplash, setShowSplash] = useState(true);
  localStorage.setItem("splashShown","Y");
if(!splashScreens.length && !localStorage.getItem("splashShown")){
       setShowSplash(false);
        onFinish(false);
  }
   const skipLogin = () => {
         localStorage.setItem('isLoginSkipped', 'Y');
         setting.branches.length?history.push('/choose-branch?' + window.location.href.split('?')[1]):
                history.push('/order?' + window.location.href.split('?')[1]);

    }
  useEffect(() => {
    if(!splashScreens.length && !localStorage.getItem("splashShown")){
       setShowSplash(false);
        onFinish(false);
  }
    if (currentSplash < splashScreens.length-1) {
      const timer = setTimeout(() => {
        setCurrentSplash(currentSplash + 1);
      }, 5000); // Each splash screen displays for 2 seconds
      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => {
        setShowSplash(false);
        onFinish(false);
      }, 5000); // Last splash screen
      return () => clearTimeout(timer);
    }
  }, [currentSplash]);
  return (
    <div className="page-wrapper" id="splashScreens" style={{textAlign:"center",display:"flex", justifyContent:"center",overflow:"hidden"}}>
      <Box
        style={{
          height: '100vh',
          width: '100vw',
          backgroundImage: `url(${splashScreens[currentSplash]?.url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Overlay */}
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }}
        />

 
        {currentSplash === 0 && (
          <div style={{textAlign:"center",zIndex:2}}>
  <img
    src={setting.logoImg}
    alt="Coffee Logo"
    style={{
      width: '312px',
      height: 'auto',
      marginBottom: '20px',
      animation: 'fadeIn 1s ease-in-out',
      zIndex: 1,
      borderRadius:"10px"
    }}
  /> <Typography
      variant="h4"
      style={{
        color: '#fff',
        fontFamily: setting.themePrimaryFontFam,
        fontWeight: 700,
        textAlign: 'center',
        zIndex: 1,
        animation: 'slideUp 1s ease-in-out',
      }}
    >
      {splashScreens[currentSplash]?.caption}
    </Typography></div>
)}

      
    {currentSplash !== 0 && (
  <Box
    style={{
      paddingBottom: '200px', 
      zIndex: 1,
    }}
  >
    <Typography
      variant="h4"
      style={{
        color: '#fff',
        fontWeight: 700,
        textAlign: 'center',
         fontFamily: setting.themePrimaryFontFam,
        animation: 'slideUp 1s ease-in-out',
      }}
    >
      {splashScreens[currentSplash]?.caption}
    </Typography>

    <Typography
      variant="body1"
      style={{
        marginTop: '20px',
        color: setting.themeTxtColor,
        fontFamily: setting.themeSecondaryFontFam,
        textAlign: 'center',
        padding: '0 30px',
        animation: 'fadeIn 1.2s ease-in-out',
      }}
    >
      {splashScreens[currentSplash]?.sub_caption}
    </Typography>
  </Box>
)}
      </Box>
     <div style={{ position: "absolute",
    bottom: "60px",}}>
     <h1 style={{ textShadow:"0 0 5px #fff, 0 0 7px #fff"}}>Welcome!</h1>
      <Button 
  variant="contained"
  
  onClick={() => {
    setShowSplash(false);
        onFinish(false);
  }}
  style={{
    backgroundColor: setting.themeTxtColor, // ✅ Fixed: single '#'
    color: setting.themeColor,
    borderRadius: "8px",
    padding: "10px",
    fontWeight: "bold",
    width: "200px",
    textTransform: "uppercase",
    fontFamily: setting.themeSecondaryFontFam,
   
   
  }}
>
  Login & Get Started
</Button>

<Button 
  variant="outline"
  
  onClick={() => {
    setShowSplash(false);
        onFinish(false);
        skipLogin();
  }}
  style={{
    color: setting.themeColor,
    borderRadius: "8px",
    border:"1px solid "+setting.themeTxtColor,
    padding: "10px",
    fontWeight: "bold",
    marginTop:"20px",
    width: "200px",
    textTransform: "uppercase",
    fontFamily: setting.themeSecondaryFontFam,
    backgroundColor:"#fff"
  }}
>
  Continue as guest
</Button>
</div>
  {splashScreens.length && splashScreens.map(spl => <img src={spl && spl.url} style={{width:"1px",height:"1px",visibility:"hidden"}} />)}
    </div>
  
  );
};


export default SplashScreen;
